export const getStyles = mobileDevice => ({
  confirmDialog: {
    '& .ms-Dialog-content': {
      marginBottom: '40px',

      '& p, & div': {
        marginBottom: '15px',
      },
    },

    '& .ms-Dialog-action': {
      marginBottom: '30px',

      '&:first-child': {
        marginLeft: '0',
      },

      [mobileDevice]: {
        margin: '0px 8px 20px 0px',
      },
    },

    '& button.dialog-help': {
      fontSize: '14px',
    },
  },
});
